<template>
  <v-sheet class="transparent-background-color">
    <div
      class="caption grey--text input-chip-group-label"
      :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
    >
      {{ $t("SubAccountType.title") }}
    </div>
    <v-chip-group v-model="model" column multiple class="mx-1">
      <v-chip
        v-for="stat in status"
        small
        label
        filter
        class="mx-1"
        color="primary"
        text-color="white"
        :key="stat.value"
        :value="stat.value"
        >{{ stat.text }}</v-chip
      >
    </v-chip-group>
  </v-sheet>
</template>

<script>
import SubAccountSettings from "@/api/sub_account_settings";

export default {
  name: "SearcherSubAccountSettings",

  props: ["value"],

  computed: {
    status() {
      var status = [];
      if (this.subAccountSettings) {
        const keys = Object.keys(this.subAccountSettings);
        keys.map((key) => {
          const Description = key + "-" + this.subAccountSettings[key].name;
          status.push({ value: key, text: Description });
        });
      }
      return status;
    },
  },

  data: () => ({
    model: [],
    subAccountSettings: [],
  }),

  mounted() {
    SubAccountSettings.fetchAll().then(
      function (response) {
        if (response.data.status.isOK()) {
          this.subAccountSettings = response.data.sub_account_settings;
        }
      }.bind(this)
    );
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.model = this.value;
      },
    },
    model: {
      handler() {
        this.$emit("input", this.model);
      },
    },
    subAccountSettings: {
      handler() {
        if (!this.model || this.model.length == 0) {
          if (this.subAccountSettings) {
            this.model = Object.keys(this.subAccountSettings);
          } else {
            this.model = [];
          }
        }
      },
    },
  },
};
</script>
